"use strict";

var _classCallCheck = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var enabled = false;

var FDSTrace =
/*#__PURE__*/
function () {
  function FDSTrace() {
    _classCallCheck(this, FDSTrace);
  }

  _createClass(FDSTrace, [{
    key: "log",
    value: function log() {
      if (enabled === true) {
        var _console;

        (_console = console).log.apply(_console, arguments);
      }
    }
  }, {
    key: "time",
    value: function time(a) {
      if (enabled === true) {
        console.time(a);
      }
    }
  }, {
    key: "timeEnd",
    value: function timeEnd(a) {
      if (enabled === true) {
        console.timeEnd(a);
      }
    }
  }]);

  return FDSTrace;
}();

var _default = new FDSTrace();

exports.default = _default;
module.exports = exports.default;